var $982d558b45395246$exports = {};
$982d558b45395246$exports = {
  "dragDescriptionKeyboard": "Premi Invio per iniziare a trascinare.",
  "dragDescriptionKeyboardAlt": "Premi Alt + Invio per iniziare a trascinare.",
  "dragDescriptionLongPress": "Premi a lungo per iniziare a trascinare.",
  "dragDescriptionTouch": "Tocca due volte per iniziare a trascinare.",
  "dragDescriptionVirtual": "Fai clic per iniziare a trascinare.",
  "dragItem": function dragItem(args) {
    return "Trascina ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Trascina ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " altro elemento selezionato");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " altri elementi selezionati");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Premi Invio per trascinare ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " elemento selezionato");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementi selezionati");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Premi Alt + Invio per trascinare ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " elemento selezionato");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementi selezionati");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Premi a lungo per trascinare ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " elemento selezionato");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementi selezionati");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Hai iniziato a trascinare. Premi Tab per arrivare sull\u2019area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.",
  "dragStartedTouch": "Hai iniziato a trascinare. Arriva sull\u2019area di destinazione, quindi tocca due volte per rilasciare.",
  "dragStartedVirtual": "Hai iniziato a trascinare. Arriva sull\u2019area di destinazione, quindi fai clic o premi Invio per rilasciare.",
  "dropCanceled": "Rilascio annullato.",
  "dropComplete": "Rilascio completato.",
  "dropDescriptionKeyboard": "Premi Invio per rilasciare. Premi Esc per annullare.",
  "dropDescriptionTouch": "Tocca due volte per rilasciare.",
  "dropDescriptionVirtual": "Fai clic per rilasciare.",
  "dropIndicator": "indicatore di rilascio",
  "dropOnItem": function dropOnItem(args) {
    return "Rilascia su ".concat(args.itemText);
  },
  "dropOnRoot": "Rilascia su",
  "endDragKeyboard": "Trascinamento. Premi Invio per annullare.",
  "endDragTouch": "Trascinamento. Tocca due volte per annullare.",
  "endDragVirtual": "Trascinamento. Fai clic per annullare.",
  "insertAfter": function insertAfter(args) {
    return "Inserisci dopo ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Inserisci prima di ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Inserisci tra ".concat(args.beforeItemText, " e ").concat(args.afterItemText);
  }
};
export { $982d558b45395246$exports as default };